import { Timestamp } from '@griply/types';

import { Frequency, RRule } from '../lib/rrule';

const DAY_MS = 24 * 60 * 60 * 1000;

// rrule re-encodes dtstart's local wall clock as UTC; local addDays would drift an hour across DST.
const wallMsFromUtc = (date: Date) =>
  Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  );

const wallMsFromLocalDay = (date: Date) =>
  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

const toLocalDate = (wallMs: number): Timestamp => {
  const wall = new Date(wallMs);
  return new Date(
    wall.getUTCFullYear(),
    wall.getUTCMonth(),
    wall.getUTCDate(),
    wall.getUTCHours(),
    wall.getUTCMinutes(),
    wall.getUTCSeconds(),
  );
};

// rrule iterates from dtstart, so a far window costs O(occurrences since dtstart); null when unsafe to move.
export const getAlignedDtstart = (
  rule: RRule,
  windowStart: Timestamp,
): Timestamp | null => {
  const { dtstart, freq, interval, count, bysetpos } = rule.options;

  if (count || bysetpos?.length) {
    return null;
  }
  if (freq !== Frequency.DAILY && freq !== Frequency.WEEKLY) {
    return null;
  }

  const startWallMs = wallMsFromUtc(dtstart);
  const targetWallMs = wallMsFromLocalDay(windowStart);
  if (targetWallMs <= startWallMs) {
    return null;
  }

  const step = (interval || 1) * (freq === Frequency.WEEKLY ? 7 : 1);
  const steps = Math.floor((targetWallMs - startWallMs) / DAY_MS / step);
  if (steps <= 0) {
    return null;
  }

  return toLocalDate(startWallMs + steps * step * DAY_MS);
};
